import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { AutoSubOnDestroy } from '../../providers';
import { v4 as uuid } from 'uuid';

import MediumEditor from '@medium-editor';
import { ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

const MediumEditorOptions = {
    'imageDragging': true,
    'toolbar': {
        'buttons': [
            'bold',
            'italic',
            'underline',
            'h1', 'h2', 'h3',
            'orderedlist',
            'unorderedlist',
            'justifyLeft',
            'justifyCenter',
            'justifyRight'
        ]
    },
    'placeholder': {
        text: 'Write something fantastic here..',
        hideOnClick: true
    },
    'paste': {
        forcePlainText: false,
        cleanPastedHTML: false,
        cleanReplacements: [],
        cleanAttrs: ['class', 'style', 'dir'],
        cleanTags: ['meta'],
        unwrapTags: []
    }
}

@AutoSubOnDestroy()
@Component({
    selector: 'app-medium-editor',
    template: `
        <svg-icon class="html-edit-icon" style="font-size: 32px; position: absolute; right: 25px; z-index: 1; filter: drop-shadow(0px 0px 4px white);" [name]="htmlEditEnabled ? 'eye' : 'edit'" (click)="toggleEdit()"></svg-icon>
        <div [hidden]="htmlEditEnabled" #mediumEditor></div>
        <html-input style="pointer-events: initial; height: 60vh;" *ngIf="htmlEditEnabled" [(model)]="content"></html-input>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../../../../node_modules/medium-editor/dist/css/medium-editor.min.css',
        '../../../../node_modules/medium-editor/dist/css/themes/default.css']
})
export class MediumEditorComponent implements AfterViewInit {
    public mediumEditor: MediumEditor = null;
    public htmlEditEnabled = false;
    public content: string;

    private initSubject = new ReplaySubject<void>();

    @ViewChild('mediumEditor') editorDiv: ElementRef;

    @Input('model') set updateModel(content: string) {
        this.content = content;
        this.initSubject.pipe(first()).toPromise().then(() => {
            // Add content to editor -fix medium editor falsely showing placeholder in some cases by adding substitute string
            this.mediumEditor.setContent(content ? content : 'Add great content here');
        })
    }

    @Output('imageAdded') imageAdded = new EventEmitter<HTMLImageElement>();

    constructor() { }

    ngAfterViewInit() {
        const editorDiv: HTMLElement = this.editorDiv.nativeElement;
        this.mediumEditor = new MediumEditor(editorDiv, MediumEditorOptions);
        this.mediumEditor.subscribe('editableInput', (ev: InputEvent, editElement: HTMLElement) => {
            // Check if a child of the new node is a image
            let images = editElement.querySelectorAll('img');
            let blobImages = [];
            // Get the last added image with a blob (not the ones already uploaded)
            images.forEach(image => {
                if(image.src.startsWith('data:')) blobImages.push(image);
            });
            // Select the last image with blob (which is most likely the one just dragged in)
            let imageElement = blobImages.length > 0 ? blobImages[blobImages.length - 1] : null;

            let hasImage = imageElement ? true : true;

            // console.log(`Input type '${ev.inputType}' name: '${element.nodeName}' hasImage:'${hasImage}'`);
            // Get all images of this editor
            // let imageCount = element.querySelectorAll('.imageContainer').length;
            if(ev.inputType == 'historyUndo') {
                console.log("Undo div ", editElement);
            };

            if(ev.inputType == '' && hasImage && imageElement) {
                if(!document) return;
                // if(imageElement.classList.contains('upload-image')) {
                //     console.log("Ignore image input event (already registered)",  images.length);
                //     return;
                // }
                let imageContainer = document.createElement('div');
                // Create new uuid image/media id
                let imageKey = uuid();
                imageContainer.id = "image-container-" + imageKey;
                if(imageElement) imageElement.id = imageKey;
                imageContainer.classList.add('image-container');
                imageElement.classList.add('blog-image');
                imageElement.classList.add('small-blog-image');

                // Add image to container
                imageContainer.appendChild(imageElement);
                editElement.appendChild(imageContainer);

                // console.log(`Inserted image (has image: ${imageElement ? true : false})`, imageElement);
                this.imageAdded.emit(imageElement);
                return;
            }

            // Check parent is is a image container
            if(!editElement) return;
            let isImageContainer = editElement.classList.contains('imageContainer');
            // Check if image was deleted from container
            if((ev.inputType == 'deleteContentBackward' || ev.inputType == 'deleteContentForward') && isImageContainer && !imageElement) {
                // TODO: Implement a sustainable delete event, however this is difficult as the image div is already deleted when we get this callback.
                // For now we wont delete the image from the server when it is deleted from dom - user can do this manually in 'editor' menu
            }
        });
        this.initSubject.next();
    }

    public toggleEdit() {
        // Update before transition to new state
        this.updateContent();
        // Change editor state
        this.htmlEditEnabled = !this.htmlEditEnabled;
    }

    public updateContent(updateFromHtml: boolean = this.htmlEditEnabled) {
        // Update content in WYSIWYG editor
        if(updateFromHtml) this.mediumEditor.setContent(this.content ? this.content : 'Add great content here');
        // Update content in HTML editor
        if(!updateFromHtml) this.content = this.mediumEditor.getContent().replace(/([^\n|^\r|^ ])(<)/g, '$1\n<');;
    }
}
